import { render, staticRenderFns } from "./PaymentsDirectPayment.vue?vue&type=template&id=68d9fc0e"
import script from "./PaymentsDirectPayment.vue?vue&type=script&lang=js"
export * from "./PaymentsDirectPayment.vue?vue&type=script&lang=js"
import style0 from "./PaymentsDirectPayment.vue?vue&type=style&index=0&id=68d9fc0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports